import { ChakraFlex, ChakraText } from '@equip.health/ui';

import Counter from './Counter';

const DEFAULT_VALUE = '-';

interface PatientTableCareTeamCellProps {
  id: string;
  selectedFilter?: PatientFilterType | PatientFilterType[];
  value: string[];
}

const PatientTableCareTeamCell = ({
  id,
  selectedFilter,
  value,
}: PatientTableCareTeamCellProps) => {
  let valueToDisplay = DEFAULT_VALUE;

  if (!value?.length) return <ChakraText id={id}>{valueToDisplay}</ChakraText>;

  if (Array.isArray(selectedFilter)) {
    const matchingValueIdx = selectedFilter.findIndex(({ displayText }) =>
      value.includes(displayText),
    );
    valueToDisplay =
      matchingValueIdx !== -1
        ? selectedFilter[matchingValueIdx].displayText
        : value[0];
  } else {
    [valueToDisplay] = value;
  }

  const otherValues = value
    .filter((name: string) => name !== valueToDisplay)
    .sort((aName: string, bName: string) => aName.localeCompare(bName));

  return (
    <ChakraFlex align="center">
      <ChakraText id={`${id}__label`} marginRight="8px" width="max-content">
        {valueToDisplay}
      </ChakraText>
      {otherValues.length >= 1 && (
        <Counter
          id={id}
          tooltipLabel={
            <ChakraFlex direction="column">
              {otherValues.map((textString: string) => {
                const otherUserId = `${id}__tooltip__${textString}`;
                return (
                  <ChakraText id={otherUserId} key={otherUserId}>
                    {textString}
                  </ChakraText>
                );
              })}
            </ChakraFlex>
          }
          value={`+${otherValues.length}`}
        />
      )}
    </ChakraFlex>
  );
};

export default PatientTableCareTeamCell;
